import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { RouterModule } from '@angular/router';
interface PackagePriceDetail {
  packagePriceDetId: number;
  packageNameNameEn: string;
  packageNameNameAr: string;
  isIncluded: boolean;
  status: boolean;
}

interface PricingPackage {
  packagePriceId: number;
  packageNameEn: string;
  packageNameAr: string;
  packagePrice: number;
  yearlyDiscPerc: number;
  isVATIncluded: boolean;
  webPackagePriceDetails: PackagePriceDetail[];
}

@Component({
  selector: 'app-pricing',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterModule],
  templateUrl: './pricing.component.html',
  styleUrl: './pricing.component.scss',
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate(
          '600ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
    trigger('staggered', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(30px)' }),
        animate(
          '800ms 300ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
  ],
})
export class PricingComponent implements OnInit {
  packages: PricingPackage[] = [];
  loading = true;
  error = false;
  selectedBilling: 'monthly' | 'yearly' = 'monthly';
  currentLang: string;

  constructor(private http: HttpClient, private translateService: TranslateService) {
    this.currentLang = this.translateService.currentLang || 'en';
  }

  ngOnInit(): void {
    this.fetchPackages();

    // Subscribe to language changes
    this.translateService.onLangChange.subscribe(event => {
      this.currentLang = event.lang;
    });
  }

  fetchPackages(): void {
    this.http
      .get<PricingPackage[]>('https://pos.qootk.com/api/ZOut/packagePrice')
      .subscribe({
        next: (data) => {
          this.packages = data;
          this.loading = false;
        },
        error: (err) => {
          console.error('Error fetching pricing packages:', err);
          this.loading = false;
          this.error = true;
        },
      });
  }

  calculateYearlyPrice(price: number, discountPercentage: number): number {
    const monthlyPrice = price;
    const yearlyPrice = monthlyPrice * 12 * (1 - discountPercentage / 100);
    return Math.round(yearlyPrice * 100) / 100;
  }

  getDisplayPrice(pkg: PricingPackage): number {
    return this.selectedBilling === 'monthly'
      ? pkg.packagePrice
      : this.calculateYearlyPrice(pkg.packagePrice, pkg.yearlyDiscPerc);
  }

  toggleBilling(): void {
    this.selectedBilling =
      this.selectedBilling === 'monthly' ? 'yearly' : 'monthly';
  }

  getPackageName(pkg: PricingPackage): string {
    return this.currentLang === 'ar' ? pkg.packageNameAr : pkg.packageNameEn;
  }

  getFeatureName(feature: PackagePriceDetail): string {
    return this.currentLang === 'ar' ? feature.packageNameNameAr : feature.packageNameNameEn;
  }
}
